import {StyleParamType, wixColorParam, wixFontParam, createStylesParams} from '@wix/tpa-settings'
import {StyleType} from '@wix/editor-platform-ooi-metadata-resolver'

import {colorMetadata, fontMetadata, numberMetadata} from '../../../../../../utils/builderMetadata'

export type GeneralStylesParams = {
  generalBackgroundColor: StyleParamType.Color
  generalBorderColor: StyleParamType.Color
  generalBorderWidth: StyleParamType.Number
  generalBorderRadius: StyleParamType.Number
  generalBreadcrumbsFont: StyleParamType.Font
  generalBreadcrumbsColor: StyleParamType.Color
  generalTitleFont: StyleParamType.Font
  generalTitleColor: StyleParamType.Color
  generalSubtitleFont: StyleParamType.Font
  generalSubtitleColor: StyleParamType.Color
  generalSecondaryTitleFont: StyleParamType.Font
  generalSecondaryTitleColor: StyleParamType.Color
  generalBodyFont: StyleParamType.Font
  generalBodyColor: StyleParamType.Color
  generalDividerColor: StyleParamType.Color
  generalDividerWidth: StyleParamType.Number
}

export const generalStylesParams = createStylesParams<GeneralStylesParams>({
  generalBackgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-1', 1),
    metadata: colorMetadata(StyleType.backgroundColor, 'color-1', 1),
  },
  generalBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0),
    metadata: colorMetadata(StyleType.borderColor, 'color-5', 0),
  },
  generalBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 1}),
  },
  generalBorderRadius: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
    metadata: numberMetadata(StyleType.borderRadius, {defaultValue: 0}),
  },
  generalBreadcrumbsFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  generalBreadcrumbsColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  generalTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: (params) =>
      wixFontParam('Page-title', {
        htmlTag: 'h1',
        size: params.isMobile ? 28 : 32,
      })(params),
    metadata: fontMetadata('Page-title', 32, 28),
  },
  generalTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  generalSubtitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16, htmlTag: 'p'}),
    metadata: fontMetadata('Body-M', 16),
  },
  generalSubtitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  generalSecondaryTitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16, htmlTag: 'h2'}),
    metadata: fontMetadata('Body-M', 16),
  },
  generalSecondaryTitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  generalBodyFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {size: 16}),
    metadata: fontMetadata('Body-M', 16),
  },
  generalBodyColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5'),
    metadata: colorMetadata(StyleType.color, 'color-5'),
  },
  generalDividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam('color-5', 0.3),
    metadata: colorMetadata(StyleType.borderColor, 'color-5', 0.3),
  },
  generalDividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
    metadata: numberMetadata(StyleType.borderWidth, {defaultValue: 1}),
  },
})
